module.exports = __webpack_public_path__ + "static/media/rafael_silva.b6df66a8.jpg";